import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "../lib/api";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const orderId = params.get("order_id");
  const [status, setStatus] = useState("checking");
  const [info, setInfo] = useState(null);

  useEffect(() => {
    if (!orderId) { setStatus("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${orderId}`);
        setInfo(data);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (["failed", "expired"].includes(data.payment_status)) { setStatus("failed"); return; }
      } catch (e) { /* keep trying */ }
      if (tries++ < 6) setTimeout(poll, 1500); else setStatus("pending");
    };
    poll();
  }, [orderId]);

  return (
    <div className="pt-20 min-h-screen flex items-center justify-center bg-paper-2 px-6">
      <div className="max-w-lg text-center border border-line bg-paper p-12" data-testid="payment-success">
        <span className="label text-wheat">Prairie Prints MT</span>
        {status === "checking" && <h1 className="font-serif text-5xl tracking-tight mt-4">Confirming your order…</h1>}
        {status === "paid" && (
          <>
            <h1 className="font-serif text-5xl tracking-tight mt-4">Thank you.</h1>
            <p className="text-stone mt-4">Your print{info?.print_title && String(info.print_title).includes("|") ? "s" : ""}{info?.print_title ? ` — ${info.print_title}` : ""} {info?.print_title && String(info.print_title).includes("|") ? "are" : "is"} on the way to our photo lab. A confirmation is in your inbox.</p>
          </>
        )}
        {status === "pending" && <h1 className="font-serif text-4xl tracking-tight mt-4">Your payment is processing. We'll email you shortly.</h1>}
        {(status === "failed" || status === "error") && <h1 className="font-serif text-4xl tracking-tight mt-4">We couldn't confirm that payment.</h1>}
        <Link to="/" data-testid="success-home-btn" className="inline-block mt-10 label bg-ink text-paper px-8 py-4 hover:bg-brick transition-colors">Back home</Link>
      </div>
    </div>
  );
}
